import { Component, Inject, Input, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import icClose from '@iconify/icons-ic/twotone-close';

@Component({
  selector: 'vex-video-tutorial',
  templateUrl: './video-tutorial.component.html',
  styleUrls: ['./video-tutorial.component.scss']
})
export class VideoTutorialComponent implements OnInit {

  icClose = icClose;
  
  videoURL: string;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit(): void {
    this.videoURL = this.parseVimeo(this.data.url);
  }

  /**
   * 
   * @param url : raw url
   * @returns 
   */
  private parseVimeo(url) {
    // var url = "https://vimeo.com/manage/videos/297996592/1fcf8250d5";
    var regExp = /(videos|video|channels|\.com)\/([\d]+)/
    var matches = url.match(regExp);
    return matches && "https://player.vimeo.com/video/"+matches[2];
  }
}
